export enum MovementStatusEnum {
  FILE_PROCESSED_WITH_REVIEW = 'FileProcessedWithReview',
  PROCESS_FILE_WITH_PENDENCY = 'ProcessFileWithPendency',
  UNABLE_TO_START = 'UnableToStart',
  FILE_PROCESSED = 'FileProcessed',
  PROCESS_FILE = 'ProcessFile',
  NOT_STARTED = 'NotStarted',
  ERROR = 'Error',
}

export enum CompanyStatusEnum {
  REGISTER_ACCESS = 'RegisterAccess',
  PENDING_ACCESS = 'PendingAccess',
  CANCELED = 'Canceled',
  ACTIVE = 'Active',
}

export enum PlanTypeEnum {
  HEALTH = 'Health',
  DENTAL = 'Dental',
  HEALTH_DENTAL = 'HealthAndDental',
}

export enum PartnerCompaniesTypeEnum {
  MOTHER = 'Mother',
  CHILD = 'Child',
}

export enum UserStatusEnum {
  PENDING = 'Pending',
  ACTIVE = 'Active',
  ERROR = 'Error',
  PROCESSING = 'Processing',
}

export enum MovementBeneficiaryTypeEnum {
  HOLDER = 'Titular',
  RESPONSIBLE = 'Responsavel sem direito',
  DEPENDENT = 'Dependente',
  AGGREGATE = 'Agregado',
}

export enum UserProfileEnum {
  ADM = '2b5887e4-fb50-4ce9-9754-91bc9b47a4a5',
  FINANCIAL = '2acda9a4-26e5-475b-ae6a-280dfa0d9800',
  MOVEMENT = 'e1c9432f-730b-4cf1-b0d9-f0c2abfc2023',
  MASTER = '5667c194-f3dc-4620-ac01-98168ed08270',
}

export enum OperationStatusEnum {
  TYPED = 'typed',
  PENDING_DOCUMENTATION = 'pending_documentation',
  CANCELLED = 'cancelled',
  AUTHORIZED = 'authorized',
  PROCESSED = 'processed',
  DATA_UNDER_VALIDATION = 'data_under_validation',
}

export enum ReviewsEnum {
  REVIEWS = 'Críticas',
}

export enum StartDateEnum {
  START_DATE = 'Início',
}

export enum EndDateEnum {
  END_DATE = 'Fim',
}

export enum OrganizationGroupEnum {
  ORGANIZATIONAL_GROUP = 'Grupo organizacional',
}
